import { Card, Stack, Typography } from '@healthinal/ui';
import { HistoryDto, JournalDtoTopic, PatientBasicsDto } from '../../../api/generated/model';
import { getJournalTopicName } from '../../../utils/journal.ts';
import { FileLink } from '../../components/FileLink.tsx';
import { NavigateToJournalTopicButton } from '../../components/journal/NavigateToJournalTopicButton.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryJournal({ history, patient }: { history: HistoryDto; patient: PatientBasicsDto }) {
  return (
    <HistoryEntry
      history={history}
      subject={
        <Typography level={'body-lg'}>
          Neue Notiz in{' '}
          <Typography level={'title-lg'}>{history.journal && getJournalTopicName(history.journal?.topic)}</Typography>{' '}
          für
        </Typography>
      }
      action={'erfasst von'}
      patient={patient}>
      <Card>
        <Stack direction={'row'}>
          <Stack flex={1} gap={2}>
            <Typography sx={{ whiteSpace: 'pre-line' }}>{history.journal?.notes}</Typography>
            {history.journal?.file && <FileLink fileDetails={history.journal.file} />}
          </Stack>
          <Stack alignItems={'start'}>
            {history.journal && history.journal.topic !== JournalDtoTopic.NONE && (
              <NavigateToJournalTopicButton topic={history.journal?.topic} patient={patient} />
            )}
          </Stack>
        </Stack>
      </Card>
    </HistoryEntry>
  );
}
